/**
 * Environment-specific configuration for TestDrive App
 * 
 * Environment Detection:
 * - Development: NODE_ENV === 'development' 
 * - Staging: TESTDRIVE_ENVIRONMENT === 'staging' OR fallback logic
 * - Production: TESTDRIVE_ENVIRONMENT === 'production' OR fallback logic
 */

function getEnvironment(): 'development' | 'staging' | 'production' {
  // Server-side: Use environment variables
  if (typeof window === "undefined") {
    const nodeEnv = process.env.NODE_ENV;
    const testdriveEnv = process.env.TESTDRIVE_ENVIRONMENT;
    
    if (nodeEnv === 'development') return 'development';
    if (testdriveEnv === 'production') return 'production';
    if (testdriveEnv === 'staging') return 'staging';
    
    // Fallback for production builds without explicit environment
    return nodeEnv === 'production' ? 'production' : 'staging';
  }
  
  // Client-side: Use window.ENV
  const nodeEnv = window.ENV?.NODE_ENV;
  const testdriveEnv = window.ENV?.TESTDRIVE_ENVIRONMENT;
  
  if (nodeEnv === 'development') return 'development';
  if (testdriveEnv === 'production') return 'production';
  if (testdriveEnv === 'staging') return 'staging';
  
  // Fallback logic based on domain for client-side
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'development';
    }
    if (hostname.includes('app.testdrive.us')) {
      return 'production';
    }
    if (hostname.includes('staging.testdrive.us')) {
      return 'staging';
    }
  }
  
  // Final fallback
  return nodeEnv === 'production' ? 'production' : 'staging';
}

function getApiUrl(): string {
  const environment = getEnvironment();
  
  // Override for development - always use localhost
  if (environment === 'development') {
    return "http://localhost:8000/api/v1";
  }
  
  switch (environment) {
    case 'production':
      return "https://api.testdrive.us/api/v1";
    case 'staging':
      return "https://staging-api.testdrive.us/api/v1";
    default:
      return "https://staging-api.testdrive.us/api/v1";
  }
}

export const config = {
  get apiUrl() {
    return getApiUrl();
  },
  get environment() {
    return getEnvironment();
  },
};

// Log config for debugging in development only
if (typeof window !== "undefined" && config.environment === 'development') {
  console.log("[Config] Environment:", config.environment);
  console.log("[Config] API URL:", config.apiUrl);
  console.log("[Config] NODE_ENV:", process.env.NODE_ENV);
  console.log("[Config] window.ENV:", window.ENV);
}
